import { doc, getDoc, updateDoc } from "firebase/firestore";
import handleDeleteItem from "./handleDeleteItem";

export default async function handleQuantityChange(firestore, cartID, cartItemId, quantityChange, updateCartItems, collectionPath) {
  try {
    const itemRef = doc(firestore, `${collectionPath}Carts/CartsList/DataBase/${cartID}/Items/${cartItemId}`);
    const itemDoc = await getDoc(itemRef);

    if (!itemDoc.exists()) {
      console.error("Item does not exist!");
      return;
    }

    const itemData = itemDoc.data();
    const newQuantity = itemData.quantity + quantityChange;

    // Fetch the latest stock amount from Firestore
    const productRef = doc(firestore, `${collectionPath}Listings/ListingsList/DataBase/${itemData.seller_product_id}`);
    const productDoc = await getDoc(productRef);

    if (!productDoc.exists()) {
      console.error("Product does not exist!");
      await handleDeleteItem(firestore, itemData.cartID, itemData.seller_product_id, itemData.quantity, updateCartItems, collectionPath);
      return;
    }

    const productData = productDoc.data();

    // Check if the new quantity is valid based on stock amount
    if (quantityChange > 0 && productData.listing_stock_amount !== -1 && newQuantity > productData.listing_stock_amount) {
      alert("Not enough stock available");
      return;
    }

    if (newQuantity < 1) {
      await handleDeleteItem(firestore, itemData.cartID, itemData.seller_product_id, itemData.quantity, updateCartItems, collectionPath);
    } else {
      await updateDoc(itemRef, { quantity: newQuantity });
      updateCartItems((prevItems) => prevItems.map((item) => (item.id === cartItemId ? { ...item, quantity: newQuantity } : item)));
    }
  } catch (error) {
    console.error("Error in handleQuantityChange:", error);
  }
}
